import { ButtonGroup, Button, Modal } from '@veneer/core';
import { getProjectExpirationText } from '../../../helpers/expirationDate';

export type ModalDeviceProps = {
  showDeviceModal: boolean;
  expiresAt: string;
  setShowDeviceModal: (state: boolean) => void;
};

function ModalDevice(props: ModalDeviceProps) {
  const expirationDate = getProjectExpirationText(props.expiresAt);

  const onClickClose = () => {
    props.setShowDeviceModal(false);
  };

  return (
    <Modal
      id="regular-modal"
      show={props.showDeviceModal}
      title="Oops"
      footer={
        <ButtonGroup>
          <Button onClick={onClickClose}>Close</Button>
        </ButtonGroup>
      }
    >
      <p>
        You need to use the same device that you started your photobook on to finish this project. The photos you’ve
        previously uploaded are only accessible from the original device.
      </p>
      <p>Your project is accessible for [{expirationDate}]. Finish your project before it is no longer available.</p>
    </Modal>
  );
}

export default ModalDevice;
